import CONFIG from '../config';
import request from '../request';
const qz = require("qz-tray");


export function initQZTray() {
    qz.security.setCertificatePromise(function(resolve, reject) {
        // request.get("/digicert", {}, {cache: 'no-store', headers: {'Content-Type': 'text/plain'}})
        //     .then(function(data) { resolve(data) }).catch(e => { reject(e); ; console.log(e, 'digierror')});
        resolve(CONFIG.qzDigiCert);
    });

    qz.security.setSignatureAlgorithm("SHA512"); // Since 2.1
    qz.security.setSignaturePromise(function(toSign) {
       return function(resolve, reject) {
        request.get("/sign?request=" + toSign, {}, {cache: 'no-store', headers: {'Content-Type': 'text/plain'}})
             .then(function(data) { resolve( data ) }).catch(error => { reject(error)});
       };
    });

    return qz.websocket.connect().then(res => (Promise.resolve(res))).catch(e => {console.log('qzconnect error:', e); return Promise.reject(e)})

}

export  function getPrinterConfig() {
    return typeof window !== 'undefined' ? JSON.parse(localStorage.getItem('pconfig')) : {};
};

export async function setPrinterConfig (config) {
    return await localStorage.setItem('pconfig', JSON.stringify(config));
};



// WEBPACK FOOTER //
// ./src/utils/qzHelper.js